export const isVideoAvailable = (videos) => {
  const UTCDate = new Date();

  return videos.filter((video) => {
    const videoDate = new Date(video.available);

    return UTCDate > videoDate ? true : false;
  });
};
